import {
  Form,
  Input,
  Select,
  Button,
  Card,
  Spin,
  Icon,
  AutoComplete,
  InputNumber,
  Checkbox,
  TimePicker,
} from "antd";
import React, { Component } from "react";
import { showErrorToast, showSuccessToast } from "../general/ToastHelper";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { withRouter } from "react-router-dom";
import { handleError } from "../../utils/ErrorHandlers";
import Page from "../general/Page";
import { AccountGroupService } from "../../services/group/AccountGroupService";
import { FileService } from "../../services/file/FileService";
import { AccountService } from "../../services/account/AccountService";
import { UserService } from "../../services/user/UserService";
import "./CreateGroupAccount.css";

import { HistoryOutlined } from "@ant-design/icons";

import { CfgAccountService } from "../../services/cfgAccount/CfgAccountService";
import { CfgOneStepService } from "../../services/cfgOneStep/CfgOneStepService";
import { ConsoleSqlOutlined, ControlOutlined } from "@ant-design/icons";
import { convertTZToLocal, convertTZToUTCs } from "../general/DateTzHelper";
import { file } from "jszip";
import { Translation } from "react-i18next";
import i18next from "i18next";
class CreateGroupAccount extends Component {
  constructor(props) {
    super(props);
    this.props.context.setCurrentComponent("createGroups");

    this.fileService = new FileService();
    this.cfgAccountService = new CfgAccountService();
    this.groupService = new AccountGroupService();
    this.cfgOneStep = new CfgOneStepService();

    this.state = {
      groupAccount: {
        cfg: [],
      },
      formLayout: "inline",
      loading: false,
      showSwitchMode: false,
      visible: false,
      callFlowsList: [],
      fileId: "",
      tags: [],
      inputVisible: false,
      inputValue: "",
      agentUsers: [],
      numberOfConcCalls: 0,
      accountNumbers: [],
      selectedAgentNumber: [],
      accountUsers: [],
      selectedAgentNumberForAgentGroup: "",
      selectedAgentNumberOfConcCalls: 0,
      IBGNumberOfConcurrentCalls: 0,
      SXGNumberOfConcurrentCalls: 0,
      isFetching: false,
      //New added
      readyChecked: false,
      isChecked: false,
      prompts: [],
      allGroups: [],
      agentGroups: [],
      startWorkingHour: "",
      endWorkingHour: "",
      selectedVoicemailMessage: "",
      workingDays: "",
      groupNumbers:[]
    };
  }
  async getAccountData() {
    this.acc = new AccountService();
    try {
      let account = await this.acc.getAccountsByIdService(
        this.props.context.session_id,
        this.props.context.user.accountId
      );

      return account;
    } catch (e) {
      throw e;
    }
  }

  async getAllCallFlow() {
    try {
      let data = await this.fileService.getCallFlowsService(
        this.props.context.session_id
      );

      return data;
    } catch (e) {
      throw e;
    }
  }

  async getAllPrompts() {
    try {
      let data = await this.fileService.getPromptsService(
        this.props.context.session_id
      );
      return data;
    } catch (e) {
      throw e;
    }
  }

  async getAllGroups() {
    try {
      let data = await this.groupService.getAccountGroups(
        this.props.context.session_id
      );
      return data;
    } catch (e) {
      throw e;
    }
  }

  showInput = () => {
    this.setState({ inputVisible: true }, () => this.input.focus());
  };
  handleInputChange = (e) => {
    let { groupAccount } = this.state;
    groupAccount.cfg = [
      {
        key: "INBOUND_NUMBERS",
        value: e.target.value,
        configCategory: "CTI",
      },
    ];
    this.setState({ inputValue: e.target.value, groupAccount });
  };

  handleInputConfirm = () => {
    let { groupAccount } = this.state;
    const { inputValue } = this.state;
    let { tags } = this.state;
    if (inputValue && tags.indexOf(inputValue) === -1) {
      tags = [...tags, inputValue];
    }
    groupAccount.cfg = [
      {
        key: "INBOUND_NUMBERS",
        value: tags.toString(),
        configCategory: "CTI",
      },
    ];
    this.setState({ groupAccount, tags, inputVisible: false, inputValue: "" });
  };

  async componentDidMount() {
    try {
      this.setState({ isFetching: true });
      let [
        // numberOfConcCalls,
        callFlowsList,
        account,
        // accountUsers,
        prompts,
        allGroups,
      ] = await Promise.all([
        // this.getNumberOfConcCalls(),
        this.getAllCallFlow(),
        this.getAccountData(),
        // this.getAccountUsers(),
        this.getAllPrompts(),
        this.getAllGroups(),
      ]);

      let cfg = {
        pkg_name: "",

        agents_max_num: "",

        account_nums: [],
      };
      let cfgGroup = {
        group_numbers: [],
      };
      let agentGroups = allGroups.ivrList.filter(
        (item) => item.groupType === "SXG"
      );
      if (account.ivrCustomEntityObject.cfg.length) {
        account.ivrCustomEntityObject.cfg.forEach((element) => {
          if (Object.getOwnPropertyNames(element).indexOf("PKG_NAME") > -1) {
            cfg.pkg_name = element["PKG_NAME"];
          }
          if (
            Object.getOwnPropertyNames(element).indexOf("AGENTS_MAX_NUMBER") >
            -1
          ) {
            cfg.agents_max_num = element["AGENTS_MAX_NUMBER"];
          }
          if (
            Object.getOwnPropertyNames(element).indexOf("ACCOUNT_NUMBERS") > -1
          ) {
            if (element["ACCOUNT_NUMBERS"] === "") {
              cfg.account_nums = [];
            } else {
              cfg.account_nums = element["ACCOUNT_NUMBERS"].split(",");
            }
          }
          if (
            Object.getOwnPropertyNames(element).indexOf(
              "MAX_CONCURRENT_CALLS"
            ) > -1
          ) {
            cfg.SXGNumberOfConcurrentCalls = element["MAX_CONCURRENT_CALLS"];
          }
          if (
            Object.getOwnPropertyNames(element).indexOf(
              "AVAILABLE_CONCURRENT_CALLS"
            ) > -1
          ) {
            cfg.IBGNumberOfConcurrentCalls =
              element["AVAILABLE_CONCURRENT_CALLS"];
          }
        });
      }
      if (account.ivrCustomEntityObject.cfgGroup.length) {
        account.ivrCustomEntityObject.cfgGroup.forEach((element) => {
          if (
            Object.getOwnPropertyNames(element).indexOf("GROUP_NUMBERS") > -1
          ) {
            if (element["GROUP_NUMBERS"] === "") {
              cfgGroup.group_numbers = [];
            } else {
              cfgGroup.group_numbers = element["GROUP_NUMBERS"].split(",");
              cfg.account_nums = cfg.account_nums.filter((elem) => {
                if (!cfgGroup.group_numbers.includes(elem)) return elem;
              });
            }
          }
        });
      }
      this.setState({
        //numberOfConcCalls: numberOfConcCalls.ivrCustomEntityObject,
        callFlowsList: callFlowsList.ivrList,
        account: account.ivrCustomEntityObject,
        cfg: cfg,
        accountNumbers: cfg.account_nums,
        isFetching: false,
        // accountUsers: accountUsers.ivrList,
        IBGNumberOfConcurrentCalls: cfg.IBGNumberOfConcurrentCalls,
        SXGNumberOfConcurrentCalls: cfg.SXGNumberOfConcurrentCalls,
        cfgGroup: cfgGroup,
        prompts: prompts.ivrList,
        agentGroups: agentGroups,
      });
    } catch (e) {
      this.setState({ isFetching: false });
      handleError(e);
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.location.key !== this.props.location.key) {
      this.componentDidMount();
    }
  }
  handleCancel = () => {
    this.setState({ visible: false });
  };
  handleDropdownChange(value) {
    let { groupAccount, showSwitchMode } = this.state;
    groupAccount.groupType = value;
    if (value === "SXG") {
      showSwitchMode = true;
      groupAccount.cfg = [
        {
          key: "SWITCH_MODE",
          value: "0",
          configCategory: "CTI",
        },
      ];
    } else {
      showSwitchMode = false;
      groupAccount.cfg = [
        {
          key: "INBOUND_NUMBERS",
          value: this.state.tags.toString(),
          configCategory: "CTI",
        },
      ];
    }
    this.setState({ groupAccount, showSwitchMode });
  }
  handleSMDropdownChange(value) {
    let { groupAccount } = this.state;
    groupAccount.cfg[0] = {
      key: "SWITCH_MODE",
      value: value,
      configCategory: "CTI",
    };
    this.setState({ groupAccount });
  }
  handleActivateVoiceCheckBox(e) {
    let { isChecked } = this.state;
    if (e.target.checked === true) {
      isChecked = true;
    } else {
      isChecked = false;
    }
    this.setState({ isChecked });
  }

  handleReadyFlowCheckBox(e) {
    let { readyChecked } = this.state;
    readyChecked = e.target.checked === true ? true : false;
    if (!readyChecked) {
      this.props.form.setFields({
        CallFlow: {
          value: "",
        },
      });
    } else {
      this.props.form.setFields({
        CallFlow: {
          value: "CF_Ready_Flow",
        },
      });
    }
    this.setState({ readyChecked });
  }
  handleConfirm = (e) => {
    e.preventDefault();
    let history = this.props.history;
    let accountId = this.props.context.user.accountId;

    this.props.form.validateFields(async (err, values) => {
      try {

        if (!err) {
          
          this.setState({ loading: true });
          this.acc = new AccountGroupService();
          values["accountId"] = accountId;
          let cfg = [];

          if (values.groupType === "IBG") {
            cfg = [
              {
                key: "MAX_CONCURRENT_CALLS",
                value: "" + values.numberOfConcCalls,
                configCategory: "CTI",
              },
              {
                key: "GROUP_NUMBERS",
                value: "" + values["selectNumbers"],
                configCategory: "CTI",
              },
              {
                key: "READY_FLOW",
                value: values.readyFlow ? "ONE_STEP" : "None",
                configCategory: "CTI",
              },
              {
                key: "CALL_FLOW",
                value: values.readyFlow ? "CFL.ONE_STEP" : values.CallFlow =="" ? values.CallFlow : values.CallFlow +".icf",
                configCategory: "CTI",
              },
              {
                key: "ACTIVATE_VOICEMAIL",
                value: values.activateVoicemail,
                configCategory: "CTI",
              },
              {
                key: "START_WORKING_HOUR",
                value: values.startWorkingHour
                  ? convertTZToUTCs(values.startWorkingHour)
                  : "",
                configCategory: "CTI",
              },
              {
                key: "END_WORKING_HOUR",
                value: values.endWorkingHour
                  ? convertTZToUTCs(values.endWorkingHour)
                  : "",
                configCategory: "CTI",
              },
              {
                key: "VOICEMAIL_PROMPT",
                value: values.VoiceMailMessage
                  ? values.VoiceMailMessage + ".wav"
                  : "",
                configCategory: "CTI",
              },
              {
                key: "WORKING_DAYS",
                value: values.workingDays ? values.workingDays.toString() : "",
                configCategory: "CTI",
              },
            ];
          }
          if (values.groupType === "SXG") {
            cfg = [
              {
                key: "SWITCH_MODE",
                value: values.cfg[0].value,
                configCategory: "CTI",
              },
              // {
              //   key: "AGENTS_NUMBERS",
              //   value: values.selectAgentNumbers.join(),
              //   configCategory: "CTI"
              // },
              // {
              //   key: "MAX_CONCURRENT_CALLS",
              //   value: "" + values.agentNumberOfConcCalls,
              //   configCategory: "CTI",
              // },
            ];
          }
          values["isReadyFlow"] =this.state.readyChecked && values.groupType === "IBG" ?  true : false;
          values["cfgOneStep"] =  this.state.readyChecked && values.groupType === "IBG" ?  {
            accountId: this.props.context.user.accountId,
            ibgGroupId: null,
            sxgGroupId: values.sxgGroupId,
            welcomePrompt: values.welcomePrompt+".wav",
            waitingPrompt: values.waitingPrompt+".wav",
          } : null;
          let data = await this.acc.createGroupAccount(
            this.props.context.session_id,
            values,
            cfg
          );

          // if (this.state.readyChecked && values.groupType === "IBG") {
          //   let record = {
          //     accountId: this.props.context.user.accountId,
          //     ibgGroupId: data.id,
          //     sxgGroupId: values.sxgGroupId,
          //     welcomePrompt: values.welcomePrompt+".wav",
          //     waitingPrompt: values.waitingPrompt+".wav",
          //   };
          //   let readyFlowData = await this.cfgOneStep.createCfgOneStep(
          //     this.props.context.session_id,
          //     record
          //   );
          // }
          this.setState({ loading: false });

          showSuccessToast(
            i18next.t("Create Group Account Success")
          );

          this.props.form.resetFields();
          history.push("/home/groups");
        }
      } catch (e) {
        this.setState({ loading: false });
        handleError(e);
      }
    });
  };

  onSelect = (value) => {
    let { fileId } = this.state;
    fileId = value;
    this.setState({ fileId });
  };

  handleDropdownConcurrentCallChange = (e) => {
    this.setState({ inputValue: e });
  };

  saveInputRef = (input) => (this.input = input);

  async getNumberOfConcCalls() {
    try {
      // this.setState({ isFetchingGetNumberOfConcurrentCalls: true });
      let data = await this.cfgAccountService.getCurrentConcurrentCalls(
        this.props.context.session_id,
        "*"
      );

      return data;

      // this.setState({
      //   numberOfConcCalls: data.ivrCustomEntityObject,

      //   isFetchingGetNumberOfConcurrentCalls: false
      // });
    } catch (e) {
      // this.setState({ isFetchingGetNumberOfConcurrentCalls: false });
      // handleError(e);
      throw e;
    }
  }

  async getAccountUsers() {
    this.acc = new UserService();
    try {
      let data = await this.acc.getAllUsersByAccountIdService(
        this.props.context.session_id,
        this.props.context.user.accountId
      );

      return data;
    } catch (e) {
      throw e;
    }
  }
  handleChangeAgentsNumber = (selectedAgentNumber) => {
    this.setState({ selectedAgentNumber });
  };

  handleChangeAgentsNumberForAgentGroup = (
    selectedAgentNumberForAgentGroup
  ) => {
    this.setState({ selectedAgentNumberForAgentGroup });
  };
  handleChangeAgentNumberOfConcCalls = (selectedAgentNumberOfConcCalls) => {
    this.setState({ selectedAgentNumberOfConcCalls });
  };

  handleWorkingdDaysChange(values) {}

  render() {
    let {
      accountNumbers,
      selectedAgentNumber,
      selectedAgentNumberForAgentGroup,
      accountUsers,
      SXGNumberOfConcurrentCalls,
      agentGroups,
      IBGNumberOfConcurrentCalls,
      isFetching,
      groupNumbers
    } = this.state;
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };
    const format = "HH:mm";
    const { Option } = Select;

    let { callFlowsList, numberOfConcCalls, prompts } = this.state;
    const promptOptions = prompts.map((opt) => (
      <Option key={opt.fileId} value={opt.fileId}>
        {opt.name}
      </Option>
    ));

    const options = callFlowsList.map((opt) => (
      <Option key={opt.name} value={opt.fileId}>
        {opt.name}
      </Option>
    ));
    // const { RangePicker } = DatePicker;
    const numberOfConcCallsList = [];
    for (let i = 1; i <= IBGNumberOfConcurrentCalls; i++) {
      numberOfConcCallsList.push(
        <Option key={i} value={i}>
          {i}
        </Option>
      );
    }

    const agentGroupOptions = agentGroups.map((opt) => (
      <Option key={opt.groupId} value={opt.groupId}>
        {opt.groupName}
      </Option>
    ));
    return (
      <Translation>
        {(t) => (
          <Page title={t("Create Group Account")} hasBackArrow={true}>
            {isFetching ? (
              <Spin></Spin>
            ) : (
              <Card
                style={{
                  marginTop: "10px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                }}
                bordered={false}
              >
                <Form className="form-style" {...formItemLayout}>
                  <Form.Item
                    style={{ marginTop: "20px" }}
                    label={t("Group Name")}
                    {...formItemLayout}
                  >
                    {getFieldDecorator(
                      "groupName",

                      {
                        rules: [
                          {
                            required: true,
                            message: t("Please enter Group Name"),
                          },
                        ],
                      }
                    )(<Input />)}
                  </Form.Item>
                  <Form.Item label={t("Group Type")} {...formItemLayout}>
                    {getFieldDecorator(
                      "groupType",
                      { initialValue: "IBG" },
                      {
                        rules: [
                          {
                            required: true,
                            message: t("Please enter Groupe Type"),
                          },
                        ],
                      }
                    )(
                      <Select
                        style={{ width: 120 }}
                        onChange={(value) => this.handleDropdownChange(value)}
                      >
                        <Option value="IBG"> {t("Inbound")}</Option>
                        {/* <Option value="OBG"> outBound</Option> */}
                        <Option value="SXG"> {t("AgentGroup")}</Option>
                        {/* <Option value="ADM"> backOffice</Option> */}
                      </Select>
                    )}
                  </Form.Item>

                  {this.state.showSwitchMode ? (
                    <div>
                      <Form.Item label={t("Switch Mode")} {...formItemLayout}>
                        {getFieldDecorator(
                          "cfg",
                          {
                            initialValue: [this.state.groupAccount.cfg[0]],
                          },
                          {
                            rules: [
                              {
                                required: true,
                                message: t("Please enter Switch Mode"),
                              },
                            ],
                          }
                        )}

                        <Select
                          defaultValue={this.state.groupAccount.cfg[0].value}
                          style={{ width: 170 }}
                          onChange={(value) =>
                            this.handleSMDropdownChange(value)
                          }
                        >
                          <Option value="0">{t("Round Robin")}</Option>
                          <Option value="1">{t("Most Idle Time")}</Option>
                          <Option value="2">{t("Least Received Calls")}</Option>
                        </Select>
                      </Form.Item>

                      {/* <Form.Item label="Select Agent Number" {...formItemLayout}>
                    {getFieldDecorator(
                      "selectAgentNumbers",
                      {
                        initialValue: []
                      },
                      {
                        rules: [
                          {
                            required: true,
                            message: "Please select agent number"
                          }
                        ]
                      }
                    )(
                      <Select
                        mode="multiple" 
                        placeholder="Select Number"
                        value={selectedAgentNumberForAgentGroup}
                        onChange={value => this.handleChangeAgentsNumberForAgentGroup(value)}
                        style={{ width: "100%" }}
                      >
                        {accountUsers.map(item => (
                          <Select.Option key={item.userId} value={item.userNumber}>
                            {item.userName + ": " + item.userNumber}
                          </Select.Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item> */}

                      {/* <Form.Item
                    label="Number Of Concurrent Calls"
                    {...formItemLayout}
                  >
                    {getFieldDecorator(
                      "agentNumberOfConcCalls",

                      {
                        initialValue: 0,
                      },
                      {
                        rules: [
                          {
                            required: true,
                            message: "Please enter Number Of Concurrent Calls",
                          },
                        ],
                      }
                    )(<InputNumber min={0} max={SXGNumberOfConcurrentCalls} />)}
                  </Form.Item> */}
                    </div>
                  ) : (
                    <div>
                      <Form.Item
                        label={t("Number Of Concurrent Calls")}
                        {...formItemLayout}
                      >
                        {getFieldDecorator(
                          "numberOfConcCalls",

                          // {
                          //   initialValue:
                          //     numberOfConcCallsList.length !== 0
                          //       ? numberOfConcCallsList[0].props.value
                          //       : "",
                          // },
                          {
                            rules: [
                              {
                                required: true,
                                message: t(
                                  "Please Select Number Of Concurrent Calls"
                                ),
                                message:
                                  numberOfConcCallsList.length === 0
                                    ? t(
                                        "Please remove one or more from your existing groups or call 5080 for assistance"
                                      )
                                    : t(
                                        "Please Select Number Of Concurrent Calls"
                                      ),
                              },
                            ],
                          }
                        )(
                          <Select
                            style={{ width: 120 }}
                            onChange={(value) =>
                              this.handleDropdownConcurrentCallChange(value)
                            }
                          >
                            {numberOfConcCallsList}
                          </Select>
                        )}
                      </Form.Item>
                      <Form.Item
                        label={t("Business IVR Number")}
                        {...formItemLayout}
                      >
                        {getFieldDecorator(
                          "selectNumbers",

                          // {
                          //   initialValue: {groupNumbers},
                          // },
                          {
                            rules: [
                              {
                                required: true,
                                // message: t("Please enter group number"),
                                message:accountNumbers.length === 0
                                ? t(
                                    "Please remove one or more from your existing groups or call 5080 for assistance"
                                  )
                                : t(
                                    "Please enter group number"
                                  ),
                              },
                            ],
                          }
                        )(
                          <Select
                            // mode="multiple"
                            placeholder={t("Business IVR Number")}
                            value={selectedAgentNumber}
                            onChange={(value) =>
                              this.handleChangeAgentsNumber(value)
                            }
                            style={{ width: "100%" }}
                          >
                            {accountNumbers.map((item) => (
                              <Select.Option key={item} value={item}>
                                {item}
                              </Select.Option>
                            ))}
                          </Select>
                        )}
                      </Form.Item>

                      <Form.Item label={t("Call Flow")} {...formItemLayout}>
                        {getFieldDecorator(
                          "CallFlow",
                          {
                            initialValue: "",
                          },
                          {
                            rules: [
                              {
                                required: true,
                                message: t("Please enter Call Flow"),
                              },
                            ],
                          }
                        )(
                          <AutoComplete
                            className="certain-category-search"
                            dropdownClassName="certain-category-search-dropdown"
                            dropdownMatchSelectWidth={false}
                            dropdownStyle={{ width: 300 }}
                            size="large"
                            style={{ width: "100%" }}
                            placeholder={t("Select Custom Flow ")}
                            dataSource={options}
                            onSelect={this.onSelect}
                            disabled={this.state.readyChecked}
                            // value={this.state.val}
                            //onChange={this.onChange}
                            filterOption={(inputValue, option) =>
                              option.props.children
                                .toUpperCase()
                                .indexOf(inputValue.toUpperCase()) !== -1
                            }
                          >
                            <Input
                              suffix={
                                <Icon
                                  type="search"
                                  className="certain-category-icon"
                                />
                              }
                            />
                          </AutoComplete>
                        )}
                      </Form.Item>

                      {/* <Form.Item label="Ready Flow" {...formItemLayout}>
                    <label>None</label>
                  </Form.Item> */}
                      <Form.Item label={t("Ready Flow")} {...formItemLayout}>
                        {getFieldDecorator(
                          "readyFlow",
                          { initialValue: false },
                          {
                            rules: [
                              {
                                required: false,
                                message: "",
                              },
                            ],
                          }
                        )(
                          <Checkbox
                            onChange={(e) => {
                              this.handleReadyFlowCheckBox(e);
                            }}
                          ></Checkbox>
                        )}
                      </Form.Item>
                      {this.state.readyChecked ? (
                        <div>
                          <Form.Item
                            label={t("Welcome Message")}
                            {...formItemLayout}
                          >
                            {getFieldDecorator("welcomePrompt", {
                              initialValue:
                                promptOptions.length !== 0
                                  ? promptOptions[0].props.value
                                  : "",

                              rules: [
                                {
                                  required: true,
                                  message: t("Please select welcome message"),
                                },
                              ],
                            })(
                              <Select
                                style={{ width: "100%" }}
                                // onChange={(value) =>
                                //   this.handleDropdownChange(value)
                                // }
                              >
                                {promptOptions}
                              </Select>
                            )}
                          </Form.Item>

                          <Form.Item
                            label={t("Waiting Message")}
                            {...formItemLayout}
                          >
                            {getFieldDecorator("waitingPrompt", {
                              initialValue:
                                promptOptions.length !== 0
                                  ? promptOptions[0].props.value
                                  : "",

                              rules: [
                                {
                                  required: true,
                                  message: t("Please select waiting message"),
                                },
                              ],
                            })(
                              <Select
                                style={{ width: "100%" }}
                                // onChange={(value) =>
                                //   this.handleDropdownChange(value)
                                // }
                              >
                                {promptOptions}
                              </Select>
                            )}
                          </Form.Item>

                          <Form.Item
                            label={t("Agent Group Name")}
                            {...formItemLayout}
                          >
                            {getFieldDecorator("sxgGroupId", {
                              initialValue:
                                agentGroupOptions.length !== 0
                                  ? agentGroupOptions[0].props.value
                                  : "",
                              rules: [
                                {
                                  required: true,
                                  message: t("Please select Agent Group"),
                                },
                              ],
                            })(
                              <Select
                                style={{ width: "100%" }}
                                // onChange={(value) =>
                                //   this.handleDropdownChange(value)
                                // }
                              >
                                {agentGroupOptions}
                              </Select>
                            )}
                          </Form.Item>
                        </div>
                      ) : (
                        <></>
                      )}

                      <Form.Item
                        label={t("Activate VoiceMail")}
                        {...formItemLayout}
                      >
                        {getFieldDecorator(
                          "activateVoicemail",
                          { initialValue: false },
                          {
                            rules: [
                              {
                                required: false,
                                message: "",
                              },
                            ],
                          }
                        )(
                          <Checkbox
                            onChange={(e) => {
                              this.handleActivateVoiceCheckBox(e);
                            }}
                          ></Checkbox>
                        )}
                      </Form.Item>
                      {this.state.isChecked ? (
                        <div>
                          <Form.Item
                            label={t("Working Days")}
                            {...formItemLayout}
                          >
                            {getFieldDecorator(
                              "workingDays",

                              {
                                rules: [
                                  {
                                    required: true,
                                    message: t("Please select working days"),
                                  },
                                ],
                              }
                            )(
                              <Select
                                mode="multiple"
                                allowClear
                                style={{ width: "100%" }}
                                placeholder={t("Please select working days")}
                                onChange={(values) => {
                                  this.handleWorkingdDaysChange(values);
                                }}
                                //options={WorkingOptions}
                              >
                                <Option value="0">{t("Sunday")}</Option>
                                <Option value="1">{t("Monday")}</Option>
                                <Option value="2">{t("Tuesday")}</Option>
                                <Option value="3">{t("Wednesday")}</Option>
                                <Option value="4">{t("Thursday")}</Option>
                                <Option value="5">{t("Friday")}</Option>
                                <Option value="6">{t("Saturday")}</Option>
                              </Select>
                            )}
                          </Form.Item>
                          <Form.Item
                            label={t("Start Working Hour")}
                            {...formItemLayout}
                          >
                            {getFieldDecorator(
                              "startWorkingHour",

                              // {
                              //   initialValue: this.state.startWorkingHour,
                              // },
                              {
                                rules: [
                                  {
                                    required: true,
                                    message: t(
                                      "Please select start working hour"
                                    ),
                                  },
                                ],
                              }
                            )(
                              <TimePicker
                                placeholder={t("Start time")}
                                // defaultValue={moment("8:00", format)}
                                format={format}
                              />
                            )}
                          </Form.Item>
                          <Form.Item
                            label={t("End Working Hour")}
                            {...formItemLayout}
                          >
                            {getFieldDecorator(
                              "endWorkingHour",

                              // {
                              //   initialValue: this.state.endWorkingHour,
                              // },
                              {
                                rules: [
                                  {
                                    required: true,
                                    message: t(
                                      "Please select end working hour"
                                    ),
                                  },
                                ],
                              }
                            )(
                              <TimePicker
                                placeholder={t("End time")}
                                // defaultValue={moment("8:00", format)}
                                format={format}
                              />
                            )}
                          </Form.Item>
                          <Form.Item
                            label={t("VoiceMail Message")}
                            {...formItemLayout}
                          >
                            {getFieldDecorator("VoiceMailMessage", {
                              initialValue:
                                promptOptions.length !== 0
                                  ? promptOptions[0].props.value
                                  : "",

                              rules: [
                                {
                                  required: true,
                                  message: t("Please select voicemail message"),
                                },
                              ],
                            })(
                              <Select
                                style={{ width: "100%" }}
                                // onChange={(value) =>
                                //   this.handleVoicemailMsgSelect(value)
                                // }
                              >
                                {promptOptions}
                              </Select>
                            )}
                          </Form.Item>
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  )}
                  <Form.Item
                    wrapperCol={{
                      xs: { span: 24, offset: 0 },
                      sm: { span: 16, offset: 8 },
                    }}
                  >
                    {" "}
                    <Button
                      className="button-submit"
                      type="primary"
                      onClick={this.handleConfirm}
                      size={"small"}
                      loading={this.state.loading}
                    >
                      {t("Submit")}
                    </Button>
                  </Form.Item>
                </Form>
              </Card>
            )}
          </Page>
        )}
      </Translation>
    );
  }
}
export default Form.create()(
  withSharedStateConsumer(withRouter(CreateGroupAccount))
);
